import React, { useState } from "react";
import {
  MDBBox,
  MDBBtn,
  MDBBtnGroup,
  MDBListGroup,
  MDBListGroupItem,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
} from "mdbreact";
import { useDispatch, useSelector } from "react-redux";

import Loading from "../ui-components/loading";

import { choseToggle } from "helpers/toggleIfLoading";
import addNotification from "helpers/notify";
import { assignUserToBrand } from "api/users/addUserToBrand";
import { removeUserFromBrand } from "api/users/removeUserFromBrand";
import { Maybe } from "helpers/maybeFunctor";
import { useSearch } from "hooks/useSearch";
import { useHttp } from "hooks/useHttp";
import {
  addUserToBrand as addUserToBrandRedux,
  removeUserFromBrand as removeUserFromBrandRedux,
} from "actions/user";
import { eventTrack } from "helpers/ga4Helper";
const Members = (props) => {
  const { brandListToEdit } = props;

  const usersRedux = useSelector((s) => s.user.users);
  const brandsRedux = useSelector((s) => s.user.brands);
  const emailRedux = useSelector((s) => s.user.userInfo.email);

  const dispatch = useDispatch();
  const search = useSearch();

  const [searchValue, setSearchValue] = useState("");
  const [isAddPage, setIsAddPage] = useState(true);
  const [chosenUserForDelete, setChosenUserForDelete] = useState(null);
  const [chosenUserForAdd, setChosenUserForAdd] = useState(null);

  const [btn, setBtn] = useState("AddUser");

  const toggle = () => {
    props.toggle();
    setChosenUserForDelete(null);
    setChosenUserForAdd(null);
  };

  const {
    loading: assignUserToBrandAPILoading,
    request: assignUserToBrandAPI,
  } = useHttp({
    requestCallback: assignUserToBrand,
    onLoad: (res) => {
      dispatch(addUserToBrandRedux(chosenUserForAdd, brandListToEdit));
      setChosenUserForAdd(null);
      addNotification(
        "User was successfully added to this brand!",
        "success"
      );
    },
    onError: (res) => {
      setChosenUserForAdd(null);
      addNotification("Something went wrong, please contact support", "danger");
    },
  });

  const addUserToBrand = () => {
    if (!chosenUserForAdd) {
      addNotification(
        "Choose the user you want to add to this brand",
        "default"
      );
    } else {
      return assignUserToBrandAPI({
        brand_id: brandListToEdit,
        user_id: chosenUserForAdd,
      });
    }
  };

  const {
    loading: deleteUserFromBrandLoading,
    request: removeUserFromBrandAPI,
  } = useHttp({
    requestCallback: removeUserFromBrand,
    onLoad: (res) => {
      dispatch(
        removeUserFromBrandRedux(chosenUserForDelete, brandListToEdit)
      );
      setChosenUserForDelete(null);
      addNotification(
        "User was successfully removed from this brand!",
        "success"
      );
    },
    onError: (res) => {
      addNotification("Something went wrong, please contact support", "danger");
    },
  });

  const deleteUserToBrand = () => {
    if (!chosenUserForDelete) {
      addNotification(
        "Choose the user you want to delete from this brand",
        "default"
      );
    } else {
      return removeUserFromBrandAPI({
        brand_id: brandListToEdit,
        user_id: chosenUserForDelete,
      });
    }
  };

  const brandListToEditUsers = Maybe.of(brandsRedux)
    .map((brandsRedux) =>
      brandsRedux.find((brandItem) => brandItem._id === brandListToEdit)
    )
    .map((brand) => brand.users).value;

  const usersAbleToAdd = Maybe.of(usersRedux)
    .map((users) => {
      if (brandListToEditUsers) {
        return users
          .filter((user) => !brandListToEditUsers?.includes(user._id))
          .filter((user) => user.email !== emailRedux);
      } else {
        return null;
      }
    })
    .map((filteredUsers) => {
      return search(filteredUsers, "email", searchValue);
    })
    .map((searchedUsers) => {
      return searchedUsers.map((user) => {
        const { name, lastName, email, _id } = user;
        return (
          <MDBListGroupItem
            key={_id}
            className="cursor-pointer p-2 member-list"
            onClick={() => setChosenUserForAdd(_id)}
            active={chosenUserForAdd === _id}
          >
            <div className="font-size-2 ">
              Name : {name} {lastName}
            </div>
            <div className="font-size-1">Email : {email}</div>
          </MDBListGroupItem>
        );
      });
    }).value;

  const usersAbleToDelete = Maybe.of(usersRedux)
    .map((users) => {
      if (brandListToEdit && brandListToEditUsers) {
        return users
          .filter((user) => brandListToEditUsers?.includes(user._id))
          .filter((user) => user.email !== emailRedux);
      } else {
        return null;
      }
    })
    .map((filteredUsers) => {
      return search(filteredUsers, "email", searchValue);
    })
    .map((searchedUsers) => {
      return searchedUsers.map((user) => {
        const { name, lastName, email, _id } = user;
        return (
          <MDBListGroupItem
            key={_id}
            className="cursor-pointer p-2 member-list"
            onClick={() => setChosenUserForDelete(_id)}
            active={chosenUserForDelete === _id}
          >
            <div className="font-size-2">
              Name : {name} {lastName}
            </div>
            <div className="font-size-1">Email : {email}</div>
          </MDBListGroupItem>
        );
      });
    }).value;

  const loading = deleteUserFromBrandLoading || assignUserToBrandAPILoading;

  return (
    <MDBModal
      toggle={choseToggle(loading, toggle)}
      isOpen={props.open}
      centered
      className="create-modal"
    >
      <MDBModalHeader
        toggle={choseToggle(loading, toggle)}
        className="d-flex mb-0 pb-2"
      >
        Brand members
      </MDBModalHeader>
      <MDBModalBody className="pt-1">
        <div
          className="btn-group btn-group-toggle toggle-group mt-3 w-100 mx-0 report-btn-group"
          data-toggle="buttons"
        >
          <label
            className={`${"btn btn-secondary py-3"} ${
              btn === "AddUser" ? "active" : ""
            }`}
            onClick={() => {
              setIsAddPage(true);
              setBtn("AddUser");
              {
                eventTrack(
                  "Add-User-Action",
                  "Add-User",
                  { searchValue },
                  { searchValue },
                  false,
                  searchValue
                );
              }
            }}
          >
            <input type="radio" name="options" id="option1" defaultChecked />
            Add User
          </label>
          <label
            className={`${"btn btn-secondary py-3"} ${
              btn === "Delete" ? "active" : ""
            }`}
            onClick={() => {
              {
                setIsAddPage(false);
                setBtn("Delete");
              }
              {
                eventTrack(
                  "Delete-User-Action",
                  "Delete-User",
                  { searchValue },
                  { searchValue },
                  false,
                  searchValue
                );
              }
            }}
          >
            <input type="radio" name="options" id="option2" />
            Delete User
          </label>
        </div>

        {isAddPage ? (
          <>
            {/* <h6 className="mt-2">Add user menu</h6> */}
            <div className="form-group mb-2">
              <input
                type="text"
                className="shared-input-search mt-2"
                placeholder="Search by email.."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <MDBListGroup className="fixes-height-members overflow-auto">
              {usersAbleToAdd}
            </MDBListGroup>
            {loading ? (
              <div className="d-flex flex-center py-2 spinner-box">
                <Loading color="black" text="Loading..." />
              </div>
            ) : null}
            <MDBBox className="d-flex justify-content-center">
              <MDBBtn
                size="sm"
                color=""
                className="btn-header active-toggle mt-4 capitalize f-15"
                onClick={() => {
                  addUserToBrand();
                  {
                    eventTrack(
                      "Add-User-Action",
                      "Add-User",
                      { searchValue },
                      { searchValue },
                      false,
                      searchValue
                    );
                  }
                }}
                disabled={loading}
              >
                <i className="fa fa-plus mr-2"></i>
                Add this user
              </MDBBtn>
            </MDBBox>
          </>
        ) : (
          <>
            {/* <h6 className="mt-2">Delete user menu</h6> */}
            <div className="form-group mb-2">
              <input
                type="text"
                className="shared-input-search mt-2"
                placeholder="Search by email.."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <MDBListGroup className="fixes-height-members overflow-auto">
              {usersAbleToDelete}
            </MDBListGroup>
            {loading ? (
              <div className="d-flex flex-center py-2 spinner-box">
                <Loading color="black" text="Loading..." />
              </div>
            ) : null}
            <MDBBox className="d-flex justify-content-center">
              <MDBBtn
                size="sm"
                color=""
                className="btn-header active-toggle mt-4 capitalize f-15 bg-danger"
                onClick={() => {deleteUserToBrand()
                  {
                    eventTrack(
                      "Delete-User-From-Brand-Action",
                      "Delete-User-From-Brand",
                      {searchValue},
                      "+1",
                      false,
                      "+1"
                    );
                  }
                }}
                disabled={loading}
              >
                <i className="fa fa-trash mr-2"></i>
                Remove this user
              </MDBBtn>
            </MDBBox>
          </>
        )}
      </MDBModalBody>
    </MDBModal>
  );
};

export default Members;
